export const qualityAssurance = [
  {
    title: "Quality Assurance",
    desc: "Quality-by-design mindset backed by documented SOPs and trained teams.",
  },
  {
    title: "GMP Standards",
    desc: "GMP-aligned manufacturing practices with emphasis on consistency.",
  },
  {
    title: "Quality Control",
    desc: "In-process and release testing to ensure product integrity.",
  },
  {
    title: "Regulatory Compliance",
    desc: "Structured documentation for audits, traceability and submissions.",
  },
]

